import Vue from "vue";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import { Component, Watch } from "@/decorators";
import InformacoesAdicionaisRepresentanteModel from "@/models/informacoesAdicionaisRepresentanteModel";
import informacoesAdicionaisRepresentanteService from "@/services/informacoesAdicionaisRepresentanteService";
import { getClienteCombo, getPrescritorCombo } from "@/utils/common/combo/combotext";

@Component({
    components: {
        actionBarComponent,
        comboComponent,
        searchComboComponent,
        textareaComponent,
    },
})
export default class informacoesAdicionaisRepresentanteListComponent extends Vue {
    private tipoCadastroOptions = [
        { value: 1, text: this.$t("__.ts.cliente") },
        { value: 2, text: this.$t("__.ts.prescritor") },
    ];

    private model = new InformacoesAdicionaisRepresentanteModel();

    private customComboTextCliente = getClienteCombo;
    private customComboTextPrescritor = getPrescritorCombo;

    @Watch("model.tipoCadastro")
    private onTipoCadastroChanged() {
        this.model.registroId = null;
    }

    private async save() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                const sucesso = await informacoesAdicionaisRepresentanteService
                    .insert(this.model)
                    .withLoading()
                    .resolveWithoutJSON();

                if (sucesso) {
                    await this.$showInclusaoUpdate(this.model["id"]);

                    this.$router.back();
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }
}
